<template>
  <div class="settings-page">

    <!-- ===== HEADER ===== -->
    <div class="settings-header">
      <div>
        <h1>Settings</h1>
        <p>Manage your business preferences, integrations, and system configurations.</p>
      </div>

      <!-- <div class="header-actions">
        <button class="ghost-btn">Cancel</button>
        <button class="primary-btn">Save Changes</button>
      </div> -->
    </div>

    <!-- ===== TABS ===== -->
    <div class="settings-tabs">
      <button :class="{active: tab==='business'}" @click="tab='business'">Profile Settings</button>
      <!-- <button :class="{active: tab==='platforms'}" @click="tab='platforms'">Review Platforms</button> -->
      <button :class="{active: tab==='bussniesses'}" @click="tab='bussniesses'">
        My Businesses
      </button>
      <!-- <button :class="{active: tab==='campaigns'}" @click="tab='campaigns'">Campaign Settings</button> -->
      <button :class="{active: tab==='billing'}" @click="tab='billing'">Billing</button>
      <button :class="{active: tab==='integrations'}" @click="tab='integrations'">Integrations</button>
    </div>

    <!-- ===== TAB CONTENT ===== -->

    <!-- BUSINESS SETTINGS -->
    <!-- MY BUSINESSES -->
    <div v-if="tab==='bussniesses'" class="settings-card">

      <div class="business-header">
        <h3>My Businesses</h3>

        <button class="primary-btn" @click="openAddBusiness">
          Add Business
        </button>
      </div>

      <!-- Empty State -->
      <div v-if="bussnesses.length === 0" class="empty-state">
        No businesses found
      </div>

      <!-- Cards -->
      <div class="business-grid">

        <div v-for="buss in bussnesses" :key="buss.buss_id" class="business-card">
          <div class="business-card-header">
            <strong>{{ buss.buss_title }}</strong>
            &nbsp;
            <span>{{ buss.buss_cat }}</span>
          </div>

          <p>{{ buss.buss_desc }}</p>

          <div class="business-card-footer">
            <small>{{ buss.buss_address }}</small>

            <div class="business-actions">
              <button class="ghost-btn small" @click="editBusinessNow(buss)">
                Edit
              </button>

              <button v-if="bussnesses.length>1" class="danger-btn small" @click="askDeleteCustomer(buss)">
                Delete
              </button>
            </div>
          </div>
        </div>

      </div>

      <!-- Pagination -->
      <div class="pagination-row">

        <button class="ghost-btn" :disabled="page===0" @click="changePage(page-1)">
          Prev
        </button>

        <span>{{ page + 1 }}</span>

        <button class="ghost-btn" @click="changePage(page+1)">
          Next
        </button>

      </div>

    </div>
    <div v-if="tab==='business'" class="settings-card">

      <h3>Profile Information</h3>

      <div class="form-grid">

        <div class="form-group">
          <label>Full Name</label>
          <input v-model="profile.user_name" />
        </div>

        <div class="form-group">
          <label>Mobile Number</label>
          <input v-model="profile.user_mobile" />
        </div>

      </div>

      <button class="primary-btn" style="margin-top: 1rem;" @click="updateProfileNow">
        Update Profile
      </button>

      <hr style="margin:20px 0; border-color:#f1f5f9">

      <h3>Change Password</h3>

      <div class="form-grid">

        <div class="form-group">
          <label>Old Password</label>
          <input type="password" v-model="password.old_password" />
        </div>

        <div class="form-group">
          <label>New Password</label>
          <input type="password" v-model="password.new_password" />
        </div>

      </div>

      <button class="primary-btn" style="margin-top: 1rem;" @click="changePasswordNow">
        Change Password
      </button>

    </div>

    <!-- REVIEW PLATFORMS -->
    <div v-if="tab==='platforms'" class="settings-card">

      <h3>Connected Platforms</h3>

      <div v-for="platform in platforms" :key="platform.id" class="toggle-row">

        <div>
          <strong>{{ platform.title }}</strong>
          <p>{{ platform.description }}</p>
        </div>

        <label class="switch">
          <input type="checkbox" :checked="platform.enabled" @change="togglePlatform(platform)" />
          <span></span>
        </label>

      </div>

    </div>

    <!-- CAMPAIGN SETTINGS -->
    <div v-if="tab==='campaigns'" class="settings-card">

      <h3>Campaign Defaults</h3>

      <!-- Send Delay -->
      <div class="form-group">
        <label>Default Send Delay</label>

        <select v-model="campaignSettings.default_delay">
          <option v-for="delay in delayOptions" :key="delay.value" :value="delay.value">
            {{ delay.label }}
          </option>
        </select>
      </div>

      <!-- Auto Followups -->
      <div class="toggle-row">
        <div>
          <strong>Auto Follow-ups</strong>
          <p>Automatically send reminders if no response.</p>
        </div>

        <label class="switch">
          <input type="checkbox" v-model="campaignSettings.auto_followups" />
          <span></span>
        </label>
      </div>

    </div>

    <!-- INTEGRATIONS -->
    <div v-if="tab==='integrations'" class="settings-card">

      <h3>Integrations</h3>
      <p class="section-desc">
        Connect your review platforms and social channels.
      </p>

      <div class="integrations-grid">

        <!-- Google -->
        <div class="integration-card">

          <div class="integration-header">
            <div class="integration-info">
              <img src="/images/google.png" style="height: 2.2rem;" />
              <div>
                <strong>Google My Business</strong>
                <span>Review & Reputation Sync</span>
              </div>
            </div>

            <span v-if="google_inti==false" class="status connected">Connected</span>
            <span v-if="google_inti" class="status disconnected">Not Connected</span>
          </div>

          <p>
            Sync reviews, ratings, and customer feedback directly from Google.
          </p>

          <div v-if="google_inti==false" class="integration-actions">
            <button class="ghost-btn">Manage</button>
            <button  @click="deleteIntegrationNow('Google','google')" class="danger-btn">Disconnect</button>
          </div>
          <div v-if="google_inti" class="integration-actions">
            <button @click="saveIntegrationNow('Google')" class="primary-btn">Connect</button>
          </div>

        </div>

        <!-- Facebook -->
        <div class="integration-card">

          <div class="integration-header">
            <div class="integration-info">
              <img src="/images/facebook.png" style="height: 2.5rem;" />
              <div>
                <strong>Facebook</strong>
                <span>Social Review Tracking</span>
              </div>
            </div>

            <span v-if="fb_inti==false" class="status connected">Connected</span>
            <span v-if="fb_inti" class="status disconnected">Not Connected</span>
          </div>

          <p>
            Track Facebook recommendations and customer engagement signals.
          </p>

           <div v-if="fb_inti==false" class="integration-actions">
            <button class="ghost-btn">Manage</button>
            <button  @click="deleteIntegrationNow('Facebook','fb')" class="danger-btn">Disconnect</button>
          </div>
          <div v-if="fb_inti" class="integration-actions">
            <button @click="saveIntegrationNow('Facebook')" class="primary-btn">Connect</button>
          </div>

        </div>

        <!-- Zapier -->
        <div class="integration-card">

          <div class="integration-header">
            <div class="integration-info">
              <img src="/images/zapier.png" style="height: 2.5rem;" />
              <div>
                <strong>Zapier</strong>
                <span>Get your customers here</span>
              </div>
            </div>

            <span v-if="zap_inti==false" class="status connected">Connected</span>
            <span v-if="zap_inti" class="status disconnected">Not Connected</span>
          </div>

          <p>
            Import your customers here from CRM.
          </p>

           <div v-if="zap_inti==false" class="integration-actions">
            <button class="ghost-btn">Manage</button>
            <button  @click="deleteIntegrationNow('Zapier Auth Code','zapier')" class="danger-btn">Disconnect</button>
          </div>
          <div v-if="zap_inti" class="integration-actions">
            <button @click="saveIntegrationNow('Zapier Auth Code')" class="primary-btn">Connect</button>
          </div>

        </div>

      </div>

    </div>


    <!-- BILLING -->
    <div v-if="tab==='billing'" class="settings-card">

      <h3>Membership & Billing</h3>

      <!-- Current Plan -->
      <div class="current-plan">

        <div v-if="planDt==null">
          <span>Current Plan</span>
          <strong>Free Plan</strong>
          <p>You are on free plan.</p>
        </div>

         <div v-if="planDt!=null">
          <span>Current Plan</span>
          <strong>{{ planDt.user_plan_name }}</strong>
          <p>Renews on {{ getExpDate(planDt.user_plan_pur_date,planDt.user_plan_duration) }}</p>
        </div>

        <button class="primary-btn" @click="showPlans = true">
          Upgrade Plan
        </button>

      </div>

    </div>

    <!-- ===== PRICING MODAL ===== -->
    <div v-if="showPlans" class="plans-modal">

      <div class="plans-overlay" @click="showPlans=false"></div>

      <div class="plans-container">

        <div class="plans-header">
          <h2>Upgrade Your Plan</h2>
          <button @click="showPlans=false">✕</button>
        </div>

        <div class="plans-grid">

          <div 
            v-for="plan in plans" 
            :key="plan.plan_id"
            class="plan-card"
            :class="{ featured: plan.plan_fav === 'yes' }"
          >

            <!-- Badge -->
            <div v-if="plan.plan_fav === 'yes'" class="badge">
              Most Popular
            </div>

            <!-- Logo (optional) -->
            <div v-if="plan.plan_logo" class="plan-logo">
              <img :src="plan.plan_logo" />
            </div>

            <span>{{ plan.plan_name }}</span>

            <strong>
              ${{ plan.plan_price }} / month
            </strong>

            <p>{{ plan.plan_desc || 'Perfect plan for growing businesses.' }}</p>

            <!-- Features -->
            <ul class="features-list">
              <li 
                v-for="(f, i) in parseFeatures(plan.plan_features)" 
                :key="i"
              >
                ✔ {{ f }}
              </li>
            </ul>

            <!-- Button -->
            <button 
              v-if="plan.plan_status === 'active'"
              class="primary-btn"
              @click="choosePlan(plan)"
            >
              Choose Plan
            </button>

            <button 
              v-else
              class="ghost-btn"
            >
              Unavailable
            </button>

          </div>

        </div>


      </div>

    </div>

    <!-- BUSINESS MODAL -->
    <div v-if="showBusinessModal" class="plans-modal">

      <div class="plans-overlay" @click="showBusinessModal=false"></div>

      <div class="plans-container small-modal">

        <div class="plans-header">
          <h2>{{ businessForm.buss_id ? "Edit Business" : "Add Business" }}</h2>
          <button @click="showBusinessModal=false">✕</button>
        </div>

        <div class="form-group">
          <label>Business Title</label>
          <input v-model="businessForm.buss_title" />
        </div>

        <div class="form-group">
          <label>Category</label>
          <input v-model="businessForm.buss_cat" />
        </div>

        <div class="form-group">
          <label>Description</label>
          <input v-model="businessForm.buss_desc" />
        </div>

        <div class="form-group">
          <label>Address</label>
          <input v-model="businessForm.buss_address" />
        </div>

        <button class="primary-btn" style="margin-top: 1rem;" @click="saveBusinessNow">
          {{ businessForm.buss_id ? "Update Business" : "Save Business" }}
        </button>

      </div>
    </div>
    <!-- DELETE CONFIRMATION MODAL -->
<div v-if="deletePopup.show" class="plans-modal">

  <div class="plans-overlay" @click="deletePopup.show=false"></div>

  <div class="plans-container small-modal">

    <div class="plans-header">
      <h2>Delete Customer</h2>
      <button @click="deletePopup.show=false">✕</button>
    </div>

    <div class="confirm-body">
      <span class="material-symbols-outlined warn-icon">
        warning
      </span>

      <p>
        Are you sure you want to delete
        <strong>{{ deletePopup.name }}</strong>?
      </p>

      <small>This action cannot be undone.</small>
    </div>

    <div class="confirm-actions">
      <button class="ghost-btn" @click="deletePopup.show=false">
        Cancel
      </button>

      <button class="danger-btn" @click="confirmDeleteCustomer">
        Delete
      </button>
    </div>

  </div>
</div>
  </div>
</template>

<script>
  import { updateProfile, changePassword, getUdt } from "@/apis/userapis";
  import { getBusinessList, saveBusiness, deleteBusiness } from "@/apis/bussapis";
  import { getIntegration, deleteIntegration } from "@/apis/intigrationapis";
  import { saveUserSettings } from "@/apis/settingsapis";
  import { useToast } from 'vue-toastification';
  import { getPlanList } from "@/apis/planapis";
  // import { saveUserPlan } from "@/apis/userapis";
import { apiBaseUrl } from "@/apis/appconst";


  export default {
    name: 'MainSettingsScreen',

    data() {
      return {
        deletePopup: {
          show: false,
          customer: null,
          name: ""
        },
        campaignSettings: {

          default_delay: 24,
          auto_followups: true

        },
        page: 0,
        plans:[],
        showBusinessModal: false,

        businessForm: {
          buss_id: null,
          buss_title: '',
          buss_cat: '',
          buss_desc: '',
          buss_address: ''
        },
        delayOptions: [

          { value: 1, label: "1 Hour" },
          { value: 6, label: "6 Hours" },
          { value: 12, label: "12 Hours" },
          { value: 24, label: "24 Hours" },
          { value: 48, label: "48 Hours" }

        ],
        platforms: [

          {
            id: 1,
            title: "Google Reviews",
            description: "Collect and monitor Google customer reviews.",
            enabled: false
          },

          {
            id: 2,
            title: "Facebook Reviews",
            description: "Enable Facebook review tracking.",
            enabled: false
          },
        ],
        tab: 'profile',
        showPlans: false,
        toast: null,
        user: {},
        bussnesses: [],
        userSet: null,
        planDt: null,
        profile: {
          user_name: '',
          user_mobile: ''
        },

        password: {
          old_password: '',
          new_password: ''
        },
        google_inti:false,
        fb_inti:false,
        zap_inti:false,
      }
    },

    mounted() {
      this.toast = useToast();
      // ✅ LOAD SESSION USER
      const udata = sessionStorage.getItem("ldata");

      if (udata) {
        this.user = JSON.parse(udata);

        this.profile.user_name = this.user.user_name;
        this.profile.user_mobile = this.user.user_mobile;
      }

      if (this.$route.query.typ) {
        this.tab = this.$route.query.typ;
      }
       if (this.$route.query.err && this.$route.query.err.localeCompare("no_location")==0) {
        this.toast.error("No Google My Business profile exist in this account.");
      }
      this.getUdtNow();
      this.loadBusinesses();
      this.loadPlans();
      this.checkIniti();
      
    },

    watch: {
      campaignSettings: {
        handler(newVal, oldVal) {
          console.log("dfsdf", newVal + "-" + oldVal);
          this.saveUserSettingsNow();
        },
        deep: true
      },
      delayOptions: {
        handler(newVal, oldVal) {
          console.log("dfsdf", newVal + "-" + oldVal);
          this.saveUserSettingsNow();
        },
        deep: true
      },
      platforms: {
        handler(newVal, oldVal) {
          console.log("dfsdf", newVal + "-" + oldVal);
          this.saveUserSettingsNow();
        },
        deep: true
      },
    },
    methods: {
      askDeleteCustomer(customer) {

        this.deletePopup = {
          show: true,
          customer: customer,
          name: customer.buss_title
        };
      },
      async checkIniti(){
        this.google_inti = await this.loadIntegration("Google","google");
        this.fb_inti = await this.loadIntegration("Facebook","fb");
        this.zap_inti = await this.loadIntegration("Zapier Auth Code","zapier");
      },
      async loadIntegration(title, type) {

        try {

          const res = await getIntegration(title, type,this.user.user_id);

          if (!res.status) {
            return true;
          }
          if(res.int_dt!=null){
            return false;
          }
        } 
        catch (err) {
          console.error(err);
        }
        return true;
      },
      async saveIntegrationNow(intigration_title) {

        try {
          var link1 = "";
          if(intigration_title==="Google"){
            link1 = apiBaseUrl+"gmb/connect?uid="+this.user.user_id;
          }
          else if(intigration_title==="Zapier Auth Code"){
            link1 = apiBaseUrl+"zapier/connect?user_id="+this.user.user_id;
          }
          else{
            link1 = apiBaseUrl+"fb/connect?uid="+this.user.user_id;
          }
          if(link1.length>0){
            window.location.href = link1+"";
          }

          // const res = await saveIntegration(
          //   intigration_title,
          //   intigration_type,
          //   "",
          //   "",
          //   "",
          //   "",
          //   "active",
          //   this.user.user_id
          // );

          // if (!res.status) {
          //   this.toast.error(res.success || "unable Connect");
          //   return;
          // }

          // this.toast.success("Connected");

          // this.checkIniti();

        } 
        catch (err) {
          console.error(err);
          this.toast.error("unable Connect");
        }
      },
      async deleteIntegrationNow(intigration_title,intigration_type) {


        try {

          const res = await deleteIntegration( intigration_title,
            intigration_type,this.user.user_id);

          if (!res.status) {
            this.toast.error(res.success || "Delete failed");
            return;
          }

          this.toast.success("Disconneted");

          this.checkIniti();
        } 
        catch (err) {
          console.error(err);
          this.toast.error("Delete failed");
        }
      },
     getExpDate(purchase_date, duration_days) {

        if (!purchase_date || !duration_days) return "";

        const date = new Date(purchase_date);

        date.setDate(date.getDate() + parseInt(duration_days));

        return date.toISOString().split("T")[0];
      },
       parseFeatures(features) {
        try {
          return JSON.parse(features || "[]");
        } catch (e) {
          return [];
        }
      },

      async choosePlan(plan) {
         try {

            const url = apiBaseUrl+`/stripe/redirectToPaymentGateway?amount=${plan.plan_id}&curr=inr&uid=${this.user.user_id}`;
            window.location.href = url;

            // const res = await saveUserPlan(

            //   this.user.user_id,        // user_plan_user
            //   plan.plan_id,             // user_plan_parent
            //   plan.plan_name,           // user_plan_name
            //   plan.plan_price,          // user_plan_price
            //   plan.plan_duration,       // user_plan_duration
            //   "active"                  // user_plan_status
            // );

            // if (!res.status) {
            //   this.toast.error(res.success || "Plan upgrade failed");
            //   return;
            // }

            // this.toast.success("Plan upgraded successfully");

            this.showPlans = false;

            await this.getUdtNow();

          } catch (err) {

            console.error(err);
            this.toast.error("Plan upgrade failed");

          }
        
      },
      async loadPlans() {

        const res = await getPlanList("", "", "0");

        if (res.status) {
          this.plans = res.data || [];
        }
      },
      openAddBusiness() {
        this.resetBusinessForm();
        this.showBusinessModal = true;
      },
      async loadBusinesses() {

        const res = await getBusinessList(
          this.user.user_id,
          "active",
          this.page
        );

        if (!res.status) return;

        this.bussnesses = res.data;
        if(this.bussnesses.length<=0){
          this.toast.error("Please Add One Business");
        }
      },
      async saveBusinessNow() {

        if (!this.businessForm.buss_title) {
          this.toast.warning("Title required");
          return;
        }

        const res = await saveBusiness({
          buss_user: this.user.user_id,
          ...this.businessForm
        });

        if (!res.status) {
          this.toast.error(res.success);
          return;
        }

        this.toast.success( this.businessForm.buss_id ? "Business Updated" : "Business Added");

        this.showBusinessModal = false;

        this.businessForm = {
          
          buss_title: '',
          buss_cat: '',
          buss_desc: '',
          buss_address: ''
        };

        this.loadBusinesses();
      },
      resetBusinessForm() {
      this.businessForm = {
        buss_id:null,
        buss_title:'',
        buss_cat:'',
        buss_desc:'',
        buss_address:''
      };
    },
      editBusinessNow(buss) {

        this.businessForm = {
          buss_id: buss.buss_id,
          buss_title: buss.buss_title,
          buss_cat: buss.buss_cat,
          buss_desc: buss.buss_desc,
          buss_address: buss.buss_address
        };

        this.showBusinessModal = true;
      },
      async confirmDeleteCustomer() {

        if (!this.deletePopup.customer) return;

        try {

          const customer = this.deletePopup.customer;

          const res = await deleteBusiness(customer.buss_id);

          if (!res.status) {
            this.toast.error(res.success || "Delete failed");
            return;
          }

          this.toast.success("Customer deleted");

          this.deletePopup.show = false;

          await this.loadBusinesses();

        } catch (err) {

          console.error(err);
          this.toast.error("Delete failed");

        }
      },
      changePage(p) {
        this.page = p;
        this.loadBusinesses();
      },
      togglePlatform(platform) {

        // ✅ Toggle state manually
        platform.enabled = !platform.enabled;

        console.log("Updated Platform:", platform);
      },
      async getUdtNow() {

        try {

          const res = await getUdt(
            this.user.user_id,
          );

          if (!res.status) {
            return;
          }

          // ✅ UPDATE SESSION DATA
          this.user = res.user;
          this.bussnesses = res.bussnesses;
          this.userSet = res.userSet;
          this.planDt = res.planDt;

          if (this.userSet != null) {
            const udata = this.userSet.user_set_data1;
            if (udata) {
              const tmp = JSON.parse(udata);
              this.campaignSettings = tmp.campaignSettings;
              this.delayOptions = tmp.delayOptions;
              this.platforms = tmp.platforms;
            }
          }
        } catch (error) {
          console.error(error);
        }
      },
      async updateProfileNow() {

        if (!this.profile.user_name) {
          this.toast.warning("Name required");
          return;
        }

        try {

          const res = await updateProfile(
            this.user.user_id,
            this.profile.user_name,
            this.profile.user_mobile
          );

          if (!res.status) {
            this.toast.error(res.success);
            return;
          }

          // ✅ UPDATE SESSION DATA
          this.user.user_name = this.profile.user_name;
          this.user.user_mobile = this.profile.user_mobile;

          sessionStorage.setItem("ldata", JSON.stringify(this.user));

          this.toast.success("Profile updated");

        } catch (error) {
          console.error(error);
          this.toast.error("Update failed");
        }
      },

      async changePasswordNow() {

        if (!this.password.old_password || !this.password.new_password) {
          this.toast.warning("All fields required");
          return;
        }

        try {

          const res = await changePassword(
            this.user.user_id,
            this.password.old_password,
            this.password.new_password
          );

          if (!res.status) {
            this.toast.error(res.success);
            return;
          }

          this.toast.success("Password updated");

          this.password.old_password = '';
          this.password.new_password = '';

        } catch (error) {
          console.error(error);
          this.toast.error("Password change failed");
        }
      },
      async saveUserSettingsNow() {


        try {
          const res = await saveUserSettings(
            JSON.stringify({
              campaignSettings: this.campaignSettings,
              delayOptions: this.delayOptions,
              platforms: this.platforms
            }),
            "",
            this.user.user_id
          );

          if (!res.status) {
            return;
          }
          this.getUdt();
        } catch (error) {
          console.error(error);
        }
      }
    }
  }
</script>

<style scoped>
  .settings-page {
    padding: 28px;
    display: flex;
    flex-direction: column;
    gap: 18px;
    background: #f6f7f8;
    min-height: 100vh;
  }

  /* HEADER */
  .settings-header {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
  }

  .settings-header h1 {
    font-size: 28px;
    font-weight: 800;
  }

  .settings-header p {
    font-size: 14px;
    color: #64748b;
  }

  .header-actions {
    display: flex;
    gap: 8px;
  }

  /* TABS */
  .settings-tabs {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
  }

  .settings-tabs button {
    height: 36px;
    padding: 0 14px;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    background: white;
    font-size: 13px;
    font-weight: 600;
    color: #475569;
  }

  .settings-tabs button.active {
    background: #197fe6;
    color: white;
    border-color: #197fe6;
  }

  /* CARD */
  .settings-card {
    background: white;
    border-radius: 18px;
    padding: 22px;
    border: 1px solid #e2e8f0;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.04);
  }

  .settings-card h3 {
    font-size: 15px;
    font-weight: 700;
    margin-bottom: 16px;
  }

  /* FORM */
  .form-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 14px;
  }

  .form-group {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .form-group.full {
    grid-column: span 2;
  }

  .form-group label {
    font-size: 12px;
    font-weight: 600;
    color: #475569;
  }

  .form-group input,
  .form-group select {
    height: 40px;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    padding: 0 12px;
    font-size: 13px;
  }

  /* TOGGLES */
  .toggle-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    border-top: 1px solid #f1f5f9;
  }

  .toggle-row:first-of-type {
    border-top: none;
  }

  .toggle-row strong {
    font-size: 13px;
  }

  .toggle-row p {
    font-size: 12px;
    color: #94a3b8;
  }

  /* SWITCH */
  .switch {
    position: relative;
    width: 42px;
    height: 24px;
  }

  .switch input {
    display: none;
  }

  .switch span {
    position: absolute;
    inset: 0;
    background: #e2e8f0;
    border-radius: 20px;
    cursor: pointer;
  }

  .switch span:before {
    content: "";
    position: absolute;
    width: 18px;
    height: 18px;
    background: white;
    border-radius: 50%;
    top: 3px;
    left: 3px;
    transition: 0.2s;
  }

  .switch input:checked+span {
    background: #197fe6;
  }

  .switch input:checked+span:before {
    transform: translateX(18px);
  }

  /* BUTTONS */
  .primary-btn {
    height: 40px;
    padding: 0 16px;
    background: #197fe6;
    border-radius: 10px;
    color: white;
    font-size: 13px;
    font-weight: 600;
    border: none;
  }

  .ghost-btn {
    height: 40px;
    padding: 0 14px;
    background: white;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    font-size: 13px;
    font-weight: 600;
  }

  /* MOBILE */
  @media(max-width:768px) {

    .settings-page {
      padding: 16px;
    }

    .form-grid {
      grid-template-columns: 1fr;
    }

    .form-group.full {
      grid-column: span 1;
    }

    .header-actions {
      width: 100%;
    }

    .header-actions button {
      flex: 1;
    }
  }

  /* ================= CURRENT PLAN ================= */

  .current-plan {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: linear-gradient(135deg,
        rgba(25, 127, 230, 0.05),
        rgba(25, 127, 230, 0.01));
    border-radius: 14px;
    padding: 18px;
    border: 1px solid #e2e8f0;
  }

  .current-plan span {
    font-size: 12px;
    color: #64748b;
  }

  .current-plan strong {
    font-size: 18px;
    display: block;
    margin-top: 4px;
  }

  .current-plan p {
    font-size: 12px;
    color: #94a3b8;
    margin-top: 4px;
  }

  /* ================= MODAL ================= */

  .plans-modal {
    position: fixed;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 50;
  }

  .plans-overlay {
    position: absolute;
    inset: 0;
    background: rgba(15, 23, 42, 0.45);
    backdrop-filter: blur(4px);
  }

  /* ================= CONTAINER ================= */

  .plans-container {
    position: relative;
    width: 100%;
    max-width: 920px;
    background: white;
    border-radius: 22px;
    padding: 26px;
    box-shadow: 0 40px 80px rgba(0, 0, 0, 0.12);
    animation: modalEnter 0.25s ease;
  }

  @keyframes modalEnter {
    from {
      transform: translateY(10px) scale(0.98);
      opacity: 0;
    }

    to {
      transform: none;
      opacity: 1;
    }
  }

  /* ================= HEADER ================= */

  .plans-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }

  .plans-header h2 {
    font-size: 20px;
    font-weight: 800;
  }

  .plans-header button {
    border: none;
    background: transparent;
    font-size: 18px;
    cursor: pointer;
    color: #64748b;
  }

  /* ================= GRID ================= */

  .plans-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 14px;
  }

  /* ================= PLAN CARD ================= */

  .plan-card {
    border: 1px solid #e2e8f0;
    border-radius: 18px;
    padding: 18px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    background: white;
    transition: 0.2s;
  }

  .plan-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 14px 34px rgba(0, 0, 0, 0.06);
  }

  .plan-card span {
    font-size: 12px;
    font-weight: 600;
    color: #64748b;
  }

  .plan-card strong {
    font-size: 18px;
    font-weight: 800;
  }

  .plan-card p {
    font-size: 12px;
    color: #94a3b8;
    line-height: 1.4;
  }

  /* ================= FEATURED PLAN ================= */

  .plan-card.featured {
    border-color: #197fe6;
    background: linear-gradient(135deg,
        rgba(25, 127, 230, 0.06),
        rgba(25, 127, 230, 0.01));
  }

  /* ================= MOBILE ================= */

  @media(max-width:768px) {

    .plans-container {
      border-radius: 0;
      height: 100vh;
      max-width: 100%;
    }

    .plans-grid {
      grid-template-columns: 1fr;
    }

    .current-plan {
      flex-direction: column;
      gap: 12px;
      align-items: flex-start;
    }
  }

  /* ================= SECTION DESC ================= */

  .section-desc {
    font-size: 13px;
    color: #94a3b8;
    margin-bottom: 16px;
  }

  /* ================= GRID ================= */

  .integrations-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
    gap: 14px;
  }

  /* ================= CARD ================= */

  .integration-card {
    border: 1px solid #e2e8f0;
    border-radius: 18px;
    padding: 18px;
    background: white;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.04);
    display: flex;
    flex-direction: column;
    gap: 10px;
    transition: 0.2s;
  }

  .integration-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 14px 34px rgba(0, 0, 0, 0.06);
  }

  /* ================= HEADER ================= */

  .integration-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
  }

  .integration-info {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .integration-info strong {
    font-size: 14px;
    font-weight: 700;
    color: #0f172a;
  }

  .integration-info span {
    display: block;
    font-size: 11px;
    color: #94a3b8;
  }

  /* ================= LOGOS ================= */

  .integration-logo {
    width: 38px;
    height: 38px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 800;
    font-size: 16px;
  }

  .integration-logo.google {
    background: #197fe6;
    color: white;
  }

  .integration-logo.facebook {
    background: #1877f2;
    color: white;
  }

  /* ================= STATUS ================= */

  .status {
    padding: 4px 10px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 600;
    white-space: nowrap;
  }

  .status.connected {
    background: #dcfce7;
    color: #166534;
  }

  .status.disconnected {
    background: #f1f5f9;
    color: #475569;
  }

  /* ================= TEXT ================= */

  .integration-card p {
    font-size: 12px;
    color: #64748b;
    line-height: 1.5;
  }

  /* ================= ACTIONS ================= */

  .integration-actions {
    display: flex;
    gap: 8px;
    margin-top: 6px;
    flex-wrap: wrap;
  }

  .integration-actions button {
    flex: 1;
  }

  /* ================= DANGER BUTTON ================= */

  .danger-btn {
    height: 40px;
    padding: 0 14px;
    border-radius: 10px;
    border: 1px solid #fee2e2;
    background: #fef2f2;
    color: #dc2626;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
  }

  /* ================= MOBILE ================= */

  @media(max-width:768px) {

    .integrations-grid {
      grid-template-columns: 1fr;
    }

    .integration-actions {
      flex-direction: column;
    }

    .integration-actions button {
      width: 100%;
    }
  }

  /* ================= FEATURES LIST ================= */

  .features-list {
    list-style: none;
    padding: 0;
    margin: 4px 0 10px;
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .features-list li {
    font-size: 12px;
    color: #475569;
    display: flex;
    align-items: center;
    gap: 6px;
  }

  /* ================= BADGE ================= */

  .badge {
    align-self: flex-start;
    background: #197fe6;
    color: white;
    font-size: 10px;
    font-weight: 700;
    padding: 4px 8px;
    border-radius: 20px;
    margin-bottom: 6px;
    letter-spacing: 0.3px;
  }

  /* ================= FEATURED CARD POLISH ================= */

  .plan-card.featured {
    position: relative;
    border: 1px solid #197fe6;
    background: linear-gradient(135deg,
        rgba(25, 127, 230, 0.06),
        rgba(25, 127, 230, 0.01));
  }

  /* ================= BETTER VISUAL SPACING ================= */

  .plan-card ul {
    margin-top: 6px;
  }

  /* ================= MOBILE POLISH ================= */

  @media(max-width:768px) {

    .features-list li {
      font-size: 13px;
    }

    .badge {
      font-size: 11px;
    }
  }

  .switch span {
    transition: background 0.25s ease;
  }

  .switch span:before {
    transition: transform 0.25s ease;
  }

  .business-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
  }

  .business-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    gap: 12px;
  }

  .business-card {
    border: 1px solid #e2e8f0;
    border-radius: 14px;
    padding: 14px;
    background: white;
  }

  .business-card-header span {
    font-size: 11px;
    color: #94a3b8;
  }

  .business-card p {
    font-size: 12px;
    color: #64748b;
    margin: 6px 0;
  }

  .business-card-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .pagination-row {
    margin-top: 16px;
    display: flex;
    justify-content: center;
    gap: 12px;
    align-items: center;
  }

  .small-modal {
    max-width: 420px;
  }

  .danger-btn.small {
    height: 28px;
    font-size: 11px;
  }
  .business-actions{
  display:flex;
  gap:6px;
}

.ghost-btn.small,
.danger-btn.small{
  height:28px;
  font-size:11px;
  padding:0 10px;
}
.confirm-body {
  text-align: center;
  padding: 10px 0 20px;
}

.warn-icon {
  font-size: 46px;
  color: #dc2626;
  margin-bottom: 10px;
}

.confirm-body p {
  font-size: 14px;
  margin-bottom: 6px;
}

.confirm-body small {
  color: #94a3b8;
  font-size: 12px;
}

.confirm-actions {
  display: flex;
  gap: 10px;
  margin-top: 10px;
}

.confirm-actions button {
  flex: 1;
}
</style>